import {
  IconFunctionalErrorCircle24,
  IconFunctionalInformationCircle24,
  IconFunctionalSuccessCircle24,
} from '@cian/ui-kit-design-tokens/icons';

import { type FC, useEffect } from 'react';
import { ToastContainer, type ToastContainerProps, toast } from 'react-toastify';

import styles from './NotificationCenter.css';

export const notification = toast;

let loaded = false;

export const NotificationCenterProvider: FC<ToastContainerProps> = props => {
  useEffect(() => {
    if (!loaded) {
      import('react-toastify/dist/ReactToastify.min.css').then(() => {
        loaded = true;
      });
    }
  }, []);

  return (
    <ToastContainer
      {...props}
      hideProgressBar
      bodyClassName={styles['toast-inner']}
      closeButton={false}
      icon={(iconProps): JSX.Element | true => {
        switch (iconProps.type) {
          case 'success':
            return <IconFunctionalSuccessCircle24 color="text-positive-default" />;
          case 'error':
            return <IconFunctionalErrorCircle24 color="icon-negative-default" />;
          case 'warning':
            return <IconFunctionalInformationCircle24 color="icon-warning-default" />;
          default:
            return true;
        }
      }}
      position="bottom-right"
      toastClassName={styles['toast']}
    />
  );
};
